export const NotFound = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
    <h2>404, Not Found</h2>
  </div>
);